import React, { useEffect } from 'react';
import { SnackbarKey, useSnackbar, VariantType } from 'notistack';
import { IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { EventStartNotification, EventStartNotificationType } from '../helpers/events';

type AddNotificationProps = {
  messageError?: string;
  typeMessage?: VariantType;
};

interface ReturnHook {
  addNotification(options: AddNotificationProps): void;
}

// type TransitionProps = Omit<SlideProps, 'direction'>;

export const useHandlerNotificationApp = (): ReturnHook => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = (snackbarId: SnackbarKey | undefined) => (
    <IconButton
      aria-label="close"
      color="inherit"
      sx={{ p: 0.5 }}
      onClick={() => {
        closeSnackbar(snackbarId);
      }}
    >
      <CloseOutlined />
    </IconButton>
  );
  const addNotification = (options: AddNotificationProps) => {
    const { messageError = '', typeMessage = 'info' } = options;
    enqueueSnackbar(messageError, {
      variant: typeMessage,
      anchorOrigin: { vertical: 'top', horizontal: 'left' },
      action,
      // TransitionComponent: transitionLeft,
    });
  };

  const handlerListenerNotification = (evt: CustomEvent<EventStartNotificationType>) => {
    addNotification({
      messageError: evt.detail.message,
      typeMessage: evt.detail.messageType,
    });
  };

  useEffect(() => {
    document.addEventListener(EventStartNotification, handlerListenerNotification);
    return () => {
      document.removeEventListener(EventStartNotification, handlerListenerNotification);
    };
  }, []);

  return {
    addNotification,
  };
};
